import InsList from './InsList'
import InsCreate from './InsCreate'
import InsEdit from './InsEdit'

export default {
    list: InsList,
    edit: InsEdit,
    create: InsCreate,
};
